import * as React from "react";
const SvgArrowLineUp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M11 17H9V6.828L6.577 9.251 5.163 7.837 10 3l4.836 4.837-1.414 1.414L11 6.828V17Z"
    })
  );
export default SvgArrowLineUp20Px;
